import { render, staticRenderFns } from "./card_dynamic.vue?vue&type=template&id=6e4e0c88&scoped=true"
import script from "./card_dynamic.vue?vue&type=script&lang=js"
export * from "./card_dynamic.vue?vue&type=script&lang=js"
import style0 from "./card_dynamic.vue?vue&type=style&index=0&id=6e4e0c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e0c88",
  null
  
)

export default component.exports